import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import iconExito from '../../../assets/images/iconExito.png'
import iconLaRebaja from '../../../assets/images/iconLaRebaja.png'
import iconFarmatodo from '../../../assets/images/iconFarmatodo.png'
import iconTiendaFamilia from '../../../assets/images/iconTiendaFamilia.png'
import iconoMELI from '../../../assets/images/mercado-libre-logo.png'

import shop1CL from '../../../assets/images/shops/boton-compra-salcobrand.png'
import shop2CL from '../../../assets/images/shops/cruz-verde-desktop.png'
import shop3CL from '../../../assets/images/shops/jumbo.png'
import shop4CL from '../../../assets/images/shops/preunic-cl.png'

import shop1PE from '../../../assets/images/shops/PE/inkafarma.png'
import shop2PE from '../../../assets/images/shops/PE/metro.png'
import shop3PE from '../../../assets/images/shops/PE/mifarma.png'
import shop4PE from '../../../assets/images/shops/PE/wong.png'
import shop5PE from '../../../assets/images/shops/PE/tottus.png'
import shop6PE from '../../../assets/images/shops/PE/plazavea.png'

import shop1DO from '../../../assets/images/shops/DO/DreamClean.png'
import shop2DO from '../../../assets/images/shops/DO/FarmaciasCarol.png'
import shop3DO from '../../../assets/images/shops/DO/LaSirena.png'

import shop1PR from '../../../assets/images/shops/PR/supermaxonline.png'

import shop1EC from '../../../assets/images/shops/EC/farmaciasmedicity.png'
import shop2EC from '../../../assets/images/shops/EC/frecuento.png'
import shop3EC from '../../../assets/images/shops/EC/fybeca.png'
import shop4EC from '../../../assets/images/shops/EC/tia.png'

import shop1BO from '../../../assets/images/shops/BO/FarmaciaChavez.png'
import shop2BO from '../../../assets/images/shops/BO/farmacorp.png'
import shop3BO from '../../../assets/images/shops/BO/hansahogar.png'
import shop4BO from '../../../assets/images/shops/BO/pedidosya.png'

import shop1PY from '../../../assets/images/shops/PY/arete.png'
import shop2PY from '../../../assets/images/shops/PY/farmacenter.png'
import shop3PY from '../../../assets/images/shops/PY/stock.png'
import shop4PY from '../../../assets/images/shops/PY/superseis.png'

import './bannerShop.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import { get } from 'react-hook-form'
import { LOCALE } from '../../../constants/activity-constants'

const BannerShop = () => {
  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-prev" onClick={onClick} />
  }

  const getShops = () => {
    switch (LOCALE) {
      case 'es-CO':
        return [
          {
            img: iconTiendaFamilia,
            redirect:
              'https://www.cuidateenfamilia.com/pagina/nosotras?utm_source=nosotras&utm_medium=boton-compra&utm_campaign=cuidate-en-familia',
            className: 'iconTiendaFamilia',
            name: 'Cuidate en Familia',
          },
          {
            img: iconExito,
            redirect: 'https://www.exito.com/nosotras',
            className: 'iconExito',
            name: 'Éxito',
          },
          {
            img: iconLaRebaja,
            redirect:
              'https://www.larebajavirtual.com/nosotras?_q=nosotras&map=ft',
            name: 'La rebaja',
          },
          {
            img: iconFarmatodo,
            redirect:
              'https://www.farmatodo.com.co/buscar?product=nosotras&departamento=Todos&filtros=',
            name: 'Farmatodo',
          },
        ]
      case 'es-AR':
        return [
          {
            img: iconoMELI,
            redirect:
              'https://listado.mercadolibre.com.ar/nosotras#D[A:nosotras]',
            className: 'iconMeli',
            name: 'Mercado libre',
          },
        ]
      case 'es-CL':
        return [
          {
            img: shop1CL,
            redirect: 'https://salcobrand.cl/search_result?query=Nosotras',
            name: 'salcobrand',
            className: 'general',
          },
          {
            img: shop2CL,
            redirect: 'https://www.cruzverde.cl/search?query=Nosotras',
            name: 'Cruz Verde',
            className: 'general',
          },
          {
            img: shop3CL,
            redirect: 'https://www.jumbo.cl/busca?fq=H%3A5514',
            name: 'Jumbo',
            className: 'general',
          },
          {
            img: shop4CL,
            redirect:
              'https://preunic.cl/products/?hitsPerPage=60&refinementList%5Bbrand%5D%5B0%5D=Nosotras&utm_source=nosotras&utm_medium=proveedor&utm_campaign=nosotras_cl',
            name: 'preunic',
            className: 'general',
          },
        ]
      case 'es-PE':
        return [
          {
            img: shop1PE,
            redirect: 'https://inkafarma.pe/lista/nosotras',
            className: 'iconMeli',
            name: 'Inkafarma',
          },
          {
            img: shop2PE,
            redirect: 'https://www.metro.pe/busca/?ft=Noso',
            className: 'iconMeli',
            name: 'Metro',
          },
          {
            img: shop3PE,
            redirect: 'https://www.mifarma.com.pe/lista/nosotras',
            className: 'iconMeli',
            name: 'Mi farma',
          },
          {
            img: shop4PE,
            redirect:
              'https://www.wong.pe/busca/?fq=H%3A7205&utm_source=facebook&utm_medium=cpc&utm_campaign=27052020_f_abarrotes_nosotras',
            className: 'iconMeli',
            name: 'Wong',
          },
          {
            img: shop5PE,
            redirect:
              'https://www.tottus.com.pe/nosotras/c/?sort=recommended_web',
            className: 'iconMeli',
            name: 'Tottus',
          },
          {
            img: shop6PE,
            redirect: 'https://www.plazavea.com.pe/search/?_query=nosotras',
            className: 'iconMeli',
            name: 'Plazavea',
          },
        ]
      case 'es-DO':
        return [
          {
            img: shop1DO,
            redirect:
              'https://dreamcleanstore.com.do/products/list/search:nosotras',
            className: 'general2',
            name: 'Dream clean',
          },
          {
            img: shop2DO,
            redirect:
              'https://tienda.farmaciacarol.com/advancedsearchresult.aspx?type=any&categoryids=&keyword=nosotras&price1=&price2=&contentmenuitemids=&departmentids=&manufacturerid=&searchtype=&quick=true&isnewsearch=false',
            className: 'general2',
            name: 'Farmacias carol',
          },
          {
            img: shop3DO,
            redirect: 'https://sirena.do/products/search/nosotras',
            className: 'general2',
            name: 'La sirena',
          },
        ]
      case 'es-PR':
        return [
          {
            img: shop1PR,
            redirect:
              'https://www.supermaxonline.com/search-results.html?search=Nosotras',
            className: 'general3',
            name: 'Super Max online',
          },
        ]
      case 'es-EC':
        return [
          {
            img: shop1EC,
            redirect:
              'https://www.farmaciasmedicity.com/busqueda?controller=search&s=nosotras',
            className: 'general3',
            name: 'farmacias medicity',
          },
          {
            img: shop2EC,
            redirect:
              'https://www.frecuento.com/busqueda/?q=Nosotras&category=&stock=tru',
            className: 'general3',
            name: 'frecuento',
          },
          {
            img: shop3EC,
            redirect:
              'https://www.fybeca.com/busqueda?q=Nosotras&search-button=&lang=es_EC',
            className: 'general3',
            name: 'fybeca',
          },
          {
            img: shop4EC,
            redirect: 'https://www.tia.com.ec/nosotras',
            className: 'general3',
            name: 'tia',
          },
        ]
      case 'es-BO':
        return [
          {
            img: shop1BO,
            redirect: 'https://api.whatsapp.com/send?phone=59169203074&text=',
            className: 'general2',
            name: 'Farmacia Chavez',
          },
          {
            img: shop2BO,
            redirect:
              'https://farmacorp.com/search?type=article%2Cpage%2Cproduct&q=Nosotras*',
            className: 'general2',
            name: 'farmacorp',
          },
          {
            img: shop3BO,
            redirect:
              'https://www.hansahogar.com.bo/cuidado-personal/cuidado-femenino.html',
            className: 'general2',
            name: 'Hansa Hogar',
          },
          {
            img: shop4BO,
            redirect: 'https://www.pedidosya.com.bo/',
            className: 'general2',
            name: 'PedidosYa',
          },
        ]
      case 'es-PY':
        return [
          {
            img: shop1PY,
            redirect:
              'https://arete.com.py/catalogo?q=Nosotras&post_type=product',
            className: 'general2',
            name: 'arete',
          },
          {
            img: shop2PY,
            redirect: 'https://www.farmacenter.com.py/catalogo?q=Nosotras',
            className: 'general2',
            name: 'farmacenter',
          },
          {
            img: shop3PY,
            redirect:
              'https://www.stock.com.py/search.aspx?searchterms=Nosotras',
            className: 'general2',
            name: 'stock',
          },
          {
            img: shop4PY,
            redirect:
              'https://www.superseis.com.py/search.aspx?searchterms=Nosotras',
            className: 'general2',
            name: 'superseis',
          },
        ]
      default:
        return [
          {
            img: iconoMELI,
            redirect:
              'https://listado.mercadolibre.com.ar/nosotras#D[A:nosotras]',
            className: 'iconMeli',
            name: 'Mercado libre',
          },
        ]
    }
  }

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: getShops().length >= 3 ? 3 : getShops().length,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerMode: getShops().length < 3,
    responsive: [
      {
        breakpoint: 520,
        settings: {
          slidesToShow: getShops().length >= 2 ? 2 : 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className="f-bannerShop-container" id="shops">
      <div className="f-bannerShop-container__content">
        <section className="f-bannerShop-container__content__titleSection">
          {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
            <h2>Comprá nuestros productos en nuestros canales autorizados:</h2>
          ) : (
            <h2>Compra nuestros productos en nuestros canales autorizados:</h2>
          )}
        </section>
        <section className="f-bannerShop-container__content__containerSlider">
          <div>
            <Slider
              {...settings}
              className="f-bannerShop-container__content__containerSlider--slide"
            >
              {getShops().map((shops, index) => (
                <a
                  href={shops.redirect}
                  target="_blank"
                  key={index}
                  onClick={() =>
                    pushEventDataLayer(
                      'Interacciones - Tiendas',
                      'yogo-yogo',
                      'Click',
                      shops.name
                    )
                  }
                >
                  <img
                    src={shops.img}
                    className={shops.className}
                    alt="tienda para comprar"
                  />
                </a>
              ))}
            </Slider>
          </div>
        </section>
      </div>
    </div>
  )
}

export default BannerShop
